module.exports = __webpack_public_path__ + "static/media/135U1_Bedroom2.340f8eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U1_Bedroom2.jpg
// module id = 536
// module chunks = 0